import { request, getCompanyId } from '../utils'
import {
  ACTIVATE_MIS_PULSE,
  CREATE_MIS_PULSE,
  DEACTIVATE_MIS_PULSE,
  FETCH_MIS_PULSE_LIST,
  UPDATE_MIS_PULSE
} from '../routes/api'

class MisApi {
  static fetchMisPulseList (options, onSuccess, onError) {
    return request({ url: FETCH_MIS_PULSE_LIST , method: 'get', ...options }, onSuccess, onError);
  }

  static createMisPulse (options, onSuccess, onError) {
    return request({ url: CREATE_MIS_PULSE , params: options, method: 'post', ...options }, onSuccess, onError);
  }

  static updateMisPulse (options, onSuccess, onError) {
    return request({ url: UPDATE_MIS_PULSE(options.id) , params: options, method: 'put', ...options }, onSuccess, onError);
  }

  static deactivateMisPulse (options, onSuccess, onError) {
    return request({ url: DEACTIVATE_MIS_PULSE(options.id) , method: 'patch', ...options }, onSuccess, onError);
  }

  static activateMisPulse (options, onSuccess, onError) {
    return request({ url: ACTIVATE_MIS_PULSE(options.id) , method: 'patch', ...options }, onSuccess, onError);
  }
}

export default MisApi